import React from "react";

export default function QuickLinks() {
  return (
    <>
      {/* Extra Links and Quick Links */}
      <div className="app__footer-bottom-links" style={{ marginTop: "2.5rem" }}>
        <div
          className="app__footer-extra-links"
          style={{ marginBottom: "1.5rem" }}
        >
          <h4 className="p-text" style={{ marginBottom: "0.5rem" }}>
            Find me online:
          </h4>
          <ul
            style={{
              listStyle: "none",
              padding: 0,
              display: "flex",
              gap: "1.5rem",
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <li>
              <a
                href="https://github.com/momonaim01"
                target="_blank"
                rel="noopener noreferrer"
                className="p-text"
              >
                GitHub
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/in/abdelmounim-mouadili-6bb946283"
                target="_blank"
                rel="noopener noreferrer"
                className="p-text"
              >
                LinkedIn
              </a>
            </li>
            <li>
              <a
                href="https://tryhackme.com/p/diliabdel"
                target="_blank"
                rel="noopener noreferrer"
                className="p-text"
              >
                TryHackMe
              </a>
            </li>
            <li>
              <a href="mailto:momonaim01@gmail.com" className="p-text">
                Email
              </a>
            </li>
            <li>
              <a
                href="https://wa.me/212652182486"
                target="_blank"
                rel="noopener noreferrer"
                className="p-text"
              >
                WhatsApp
              </a>
            </li>
          </ul>
        </div>
        <div className="app__footer-quick-links">
          <h4 className="p-text" style={{ marginBottom: "0.5rem" }}>
            Quick Links:
          </h4>
          <ul
            style={{
              listStyle: "none",
              padding: 0,
              display: "flex",
              gap: "1.5rem",
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <li>
              <a href="/" className="p-text">
                Home
              </a>
            </li>
            <li>
              <a href="/#about" className="p-text">
                About
              </a>
            </li>
            <li>
              <a href="/projects" className="p-text">
                Projects
              </a>
            </li>
            <li>
              <a href="/#skills" className="p-text">
                Skills
              </a>
            </li>
            <li>
              <a href="/blogs" className="p-text">
                Blogs
              </a>
            </li>
            <li>
              <a href="/#testimonial" className="p-text">
                Testimonials
              </a>
            </li>
            <li>
              <a href="/tags" className="p-text">
                Tags
              </a>
            </li>
            <li>
              <a href="/categories" className="p-text">
                Categories
              </a>
            </li>
            <li>
              <a href="/contact" className="p-text">
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}
